import * as React from "react"
import { SVGProps } from "react"

const CyanBackdropShape = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 620 430"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		xmlnsXlink="http://www.w3.org/1999/xlink"
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M619.938.16V430H0C70.27 208.326 332.756 17.55 619.938.16Z"
			fill="url(#CyanBackdropShape_linearGradient)"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M619.938.16V430H0C70.27 208.326 332.756 17.55 619.938.16Z"
			fill="url(#CyanBackdropShape_dotPatern)"
			fillOpacity={0.5}
		/>
		<defs>
			<linearGradient
				id="CyanBackdropShape_linearGradient"
				x1={45.338}
				y1={431.492}
				x2={600.157}
				y2={42.707}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#72B2FC" />
				<stop offset={0.469} stopColor="#52B8F2" />
				<stop offset={1} stopColor="#6CDBDB" />
			</linearGradient>
			<pattern
				id="CyanBackdropShape_dotPatern"
				patternContentUnits="objectBoundingBox"
				width={0.032}
				height={0.048}
			>
				<use
					xlinkHref="#CyanBackdropShape_dotImage"
					transform="scale(.0008 .00116)"
				/>
			</pattern>
			<image
				id="CyanBackdropShape_dotImage"
				width={40}
				height={41}
				xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAApCAYAAABHomvIAAAAgklEQVRYCe3T4QmAIBCG4QbQWzk30LMJ6tqvEQqpwP75S4Re4UBE8fNRp4mGAAIIIIAAAggggAACgwjIYrNXO0pJ3uMgse4Ykrfo1c66RNcwTMhH7hOwjBGwVUDUQn29pe+ipdb1XeY5tfR+EhdtnPfX5fRsggACCCCAAAIIIPBLgQuMFkPGdY5+vgAAAABJRU5ErkJggg=="
			/>
		</defs>
	</svg>
)

export default CyanBackdropShape
